@if (isMaintenanceMode) {
  <app-maintenance></app-maintenance>
} @else {
  <nz-layout class="app-layout">
    <nz-header class="header-container">
      <app-navbar></app-navbar>
    </nz-header>
    <nz-content class="content-container" [class.no-scroll]="isAuthPage">
      <router-outlet></router-outlet>
    </nz-content>
    <nz-footer class="footer-container">
      <app-footer></app-footer>
    </nz-footer>
  </nz-layout>
}
